import { render } from "./AddSingleUserForm.vue?vue&type=template&id=fd9e5f24"
import script from "./AddSingleUserForm.vue?vue&type=script&lang=js"
export * from "./AddSingleUserForm.vue?vue&type=script&lang=js"
script.render = render

export default script